module.exports = __webpack_public_path__ + "static/divas8s-f1a41a54218c1648239a19c8d0a7dcaa.jpg";